import { Route } from '@angular/router';
import { authGuard, CallbackComponent } from '@web-client/auth';

export const appRoutes: Route[] = [
    // OAuth Callback route - processes authentication response
    {
        path: 'callback',
        component: CallbackComponent,
        title: 'Authenticating'
    },

    {
        path: '',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                redirectTo: '/dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./dashboard/dashboard.component').then(x => x.DashboardComponent),
                title: 'Dashboard'
            },
            {
                path: 'blogs',
                loadComponent: () => import('@web-client/blogs').then(x => x.BlogListComponent),
                title: 'Manage Blogs'
            },
            {
                path: 'blogs/add',
                loadComponent: () => import('@web-client/blogs').then(x => x.BlogFormComponent),
                title: 'Add New Blog'
            },
            {
                path: 'blogs/:id/edit',
                loadComponent: () => import('@web-client/blogs').then(x => x.BlogFormComponent),
                title: 'Edit Blog'
            },
            {
                path: 'blogs/:id/preview',
                loadComponent: () => import('@web-client/blogs').then(x => x.BlogViewComponent),
                data: { findBy: 'id' },
                title: 'Preview Blog'
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/dashboard'
    }
];
